// extracted by mini-css-extract-plugin
export default {"container":"MonthSelector_container__NIvbI","arrowButton":"MonthSelector_arrowButton__shyjF","arrow":"MonthSelector_arrow__UWW71","label":"MonthSelector_label__bzixz"};